import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)`
  .flex-checkbox {
    display: flex;
    flex: 1 1 0%;
    flex-direction: inherit;
    align-items: inherit;
    align-self: stretch;
    text-overflow: ellipsis;
    overflow: inherit;
    box-sizing: border-box;
  }
  
  .textarea-max {
    min-height: 45px;
  }

  .tech-comment {
    textarea {
      padding-left: 0;
    }
  }
`;
